import { useMemo } from 'react';
import { LabelBold, LabelRegular } from '@comeon/ui';
import IconBottom from '../components/icon-bottom.js';
import Collapse from './collapse.js';

const EMPTY_ARRAY = [];

const WeSpinGameRoomSelectedGames = ({ games = EMPTY_ARRAY, LabelComponent = LabelBold, translations: tr }) => {
	const selectedGamesLabels = useMemo(() => {
		return games.map(game => (
			<LabelRegular my={1} key={game.gameCode}>
				{game.gameName}
			</LabelRegular>
		));
	}, [games]);

	return (
		<Collapse
			label={tr.WE_SPIN_PREVIEW_ROOM_SELECTED_GAMES_LABEL}
			value={false}
			LabelComponent={LabelComponent}
			iconBottom={<IconBottom />}
		>
			{selectedGamesLabels}
		</Collapse>
	);
};

export default WeSpinGameRoomSelectedGames;
